module.exports = __webpack_public_path__ + "img/AlexanderUwarow_140x140_rund.a54d91b2.jpg";